import { Link, useLocation } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageUtils';

/**
 * Logo Icon (Desktop-only)
 *
 * Fixed positionierter Button oben links, gegenüber vom Login-Icon.
 * Nur auf der Landing Page sichtbar (andere Seiten haben die Sidebar mit Logo).
 * Verlinkt zur Startseite.
 *
 * Position: left-4 (spiegelbildlich zum Theme Toggle auf right-4)
 */
export const TWLogoIcon = () => {
  const location = useLocation();

  // Nur auf der Landing Page anzeigen (inkl. V2-Test-Variante)
  if (location.pathname !== '/' && location.pathname !== '/v2') {
    return null;
  }

  return (
    <Link
      to="/"
      data-mask-snap-target="logo"
      className="
        fixed top-4 left-4 sm:left-16 z-[10001]
        flex items-center justify-center
        w-10 h-10 rounded-full
        bg-[#0d0d0d]
        shadow-lg shadow-black/20
        border border-gray-800/50
        cursor-pointer
        overflow-hidden
      "
      title="RENDITEFUCHS"
      aria-label="Zur Startseite"
    >
      <img
        src={getImageUrl("/images/branding/rf-fux-yellow.svg")}
        alt="RENDITEFUCHS"
        className="w-6 h-6 object-contain transition-transform duration-300"
      />
    </Link>
  );
};

export default TWLogoIcon;
